export default [

  {
    path: '/zhiyuan/jumptopay',
    name: 'jumptopay',
    component: () => import('@/views/zhiyuan/jumptopay'),
    meta: {
      title: '正在跳转支付...'
    }
  },
  {
    path: '/zhiyuan/jumptopaytest',
    name: 'jumptopaytest',
    component: () => import('@/views/zhiyuan/jumptopaytest'),
    meta: {
      title: '正在跳转支付...'
    }
  }
  
]
